import {PaperSize} from '../../../pdf/constants'
import $ from 'jquery'
import TableDefinitionBuilder from './TableDefinitionBuilder'

export default class StackedTableDefinitionBuilder extends TableDefinitionBuilder {
    constructor(chartType, valueFormatter, categoryFormatter, tableHeaders, grandTotalValue, includeOtherUsers) {
        super(chartType, valueFormatter, categoryFormatter, grandTotalValue)

        this.includeDataOfOtherUsers = includeOtherUsers
        this.tableHeaders = tableHeaders
    }

    getTable(dataRows, margins, tableStyle) {
        return this.placeholderCtrs.stackedChartTable(dataRows, margins, tableStyle)
    }


    getDataRows(pageDataList, showDataList, showPercentsList, tableValueStyles, rowDataMaxLens) {
        const rows = []
        const preparedData = this._getPreparedData(pageDataList, showDataList, showPercentsList, tableValueStyles)
        const data = [this.tableHeaders, ...preparedData.data]
        const widths = preparedData.widths
        const valuesColumnsWidths = [widths.user, widths.team]
        if (this.includeDataOfOtherUsers) {
            valuesColumnsWidths.push(widths.notAssigned)
        }

        let valuesColumnsWidthSum = widths.total + widths.user + widths.team
        if (this.includeDataOfOtherUsers) valuesColumnsWidthSum += widths.notAssigned
        const paperWidth = this.paperSize === PaperSize.A4 ? 475 : 495
        const categoryWidth = paperWidth - valuesColumnsWidthSum

        for (let i = 0; i < data.length; i++) {
            const valuesColumns = []
            valuesColumns.push({value: data[i].user})
            valuesColumns.push({value: data[i].team})
            if (this.includeDataOfOtherUsers) {
                valuesColumns.push({value: data[i].notAssigned})
            }

            const isHeader = i === 0
            rows.push(
                this.templateCtrs.stackedValueRow(
                    data[i].category, categoryWidth,
                    data[i].total, widths.total,
                    valuesColumns, valuesColumnsWidths,
                    tableValueStyles,
                    data[i].isSecond, isHeader
                )
            )
        }

        return rows
    }

    _getPreparedData = function(pageDataList, showDataList, showPercentsList) {
        const data = []

        const charWidthCoef = 6
        const widths = {
            total: this.tableHeaders.total.length * charWidthCoef,
            user: this.tableHeaders.user.length * charWidthCoef,
            team: this.tableHeaders.team.length * charWidthCoef,
            notAssigned: this.tableHeaders.notAssigned.length * charWidthCoef,
        }

        let noUserData = true
        let noTeamData = true
        let noNotAssignedData = true

        for (let i = 0; i < pageDataList.length; i++) {
            const isSecond = i % 2 !== 0 //!counter starts with 0
            if (!$.isEmptyObject(pageDataList[i].category)) {
                const cellValue = pageDataList[i]

                const total = this.valueFormatter(cellValue.value.total)
                const userPoint = cellValue.value.userPoint
                const userTeamPoint = cellValue.value.userTeamPoint
                const notAssignedUsersPoint = cellValue.value.notAssignedUsersPoint

                const userPercent = this._getPercentValue(userPoint)
                const teamPercent = this._getPercentValue(userTeamPoint)
                const notAssignedPercent = this._getPercentValue(notAssignedUsersPoint)

                let user = ""
                let team = ""
                let notAssigned = ""

                if (showDataList) {
                    user += this.valueFormatter(userPoint)
                    team += this.valueFormatter(userTeamPoint)
                    notAssigned += this.valueFormatter(notAssignedUsersPoint)
                }

                if (showPercentsList) {
                    user += (showDataList ? "  (" : "") + userPercent + (showDataList ? ")" : "")
                    team += (showDataList ? "  (" : "") + teamPercent + (showDataList ? ")" : "")
                    notAssigned += (showDataList ? "  (" : "") + notAssignedPercent + (showDataList ? ")" : "")
                }

                if (!userPoint) {
                    user = "—"
                } else {
                    noUserData = false
                }
                if (!userTeamPoint) {
                    team = "—"
                } else {
                    noTeamData = false
                }
                if (!notAssignedUsersPoint) {
                    notAssigned = "—"
                } else {
                    noNotAssignedData = false
                }

                const formattedCategory = this.categoryFormatter(cellValue.category)

                if (widths.total < total.length * charWidthCoef) widths.total = total.length * charWidthCoef
                if (widths.user < user.length * charWidthCoef) widths.user = user.length * charWidthCoef
                if (widths.team < team.length * charWidthCoef) widths.team = team.length * charWidthCoef
                if (widths.notAssigned < notAssigned.length * charWidthCoef) widths.notAssigned = notAssigned.length * charWidthCoef

                data.push({
                    category: formattedCategory,
                    total: total,
                    user: user,
                    team: team,
                    notAssigned: notAssigned,
                    isSecond: isSecond
                })
            }
        }
        return {
            data: data,
            contains: {
                user: !noUserData,
                team: !noTeamData,
                notAssigned: !noNotAssignedData
            },
            widths,
        }
    }
}


// WEBPACK FOOTER //
// ./web/js/reports/charts/pdfgenerator/StackedTableDefinitionBuilder.js